import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { StatCollaborateurService } from "../../services/stat-collaborateur.service";
import { Utils } from "src/app/shared/utils/utils";
import {
  Chart,
  DoughnutController,
  ArcElement,
  Tooltip,
  Legend,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js';

Chart.register(
  DoughnutController,
  ArcElement,
  Tooltip,
  Legend,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale
);

const JUVENAL_ID = 27;

@Component({
  selector: "app-stats-juvenal",
  templateUrl: "./stats-juvenal.component.html",
  styleUrls: ["./stats-juvenal.component.css"],
})
export class StatsJuvenalComponent implements OnInit, OnDestroy {

  busy: Subscription;
  collaborateur: any = null;
  sousCollaborateurs: any[] = [];
  clients: any[] = [];
  stats: any = null;
  selectedSousId: number | null = null;
  isLoading: boolean = false;

  @ViewChild("actifChartJuvenal") actifChartRef: ElementRef;
  @ViewChild("htTtcChartJuvenal") htTtcChartRef: ElementRef;
  actifChart: Chart | null = null;
  htTtcChart: Chart | null = null;

  constructor(private statService: StatCollaborateurService) {}

  ngOnInit(): void {
    this.loadStats(JUVENAL_ID);
  }

  ngOnDestroy(): void {
    if (this.actifChart) this.actifChart.destroy();
    if (this.htTtcChart) this.htTtcChart.destroy();
  }

  loadStats(collaborateurId: number): void {
    this.isLoading = true;
    this.selectedSousId = null;

    this.busy = this.statService.getStatsByCollaborateur(collaborateurId).subscribe(
      (data: any) => {
        this.collaborateur      = data.collaborateur;
        this.sousCollaborateurs = data.collaborateur.sous_collaborateurs;
        this.clients            = data.clients;
        this.stats              = data.stats;
        this.isLoading          = false;
        setTimeout(() => this.renderCharts(), 100);
      },
      () => {
        Utils.sweetAlert("error", "Erreur", "Erreur lors du chargement des statistiques");
        this.isLoading = false;
      }
    );
  }

  filterBySous(sousId: number): void {
    this.isLoading = true;
    this.selectedSousId = sousId;

    this.busy = this.statService.getStatsBySousCollaborateur(JUVENAL_ID, sousId).subscribe(
      (data: any) => {
        this.clients   = data.clients;
        this.stats     = data.stats;
        this.isLoading = false;
        setTimeout(() => this.renderCharts(), 100);
      },
      () => {
        Utils.sweetAlert("error", "Erreur", "Erreur lors du chargement des statistiques");
        this.isLoading = false;
      }
    );
  }

  resetFilter(): void {
    this.loadStats(JUVENAL_ID);
  }

  renderCharts(): void {
    this.renderActifChart();
    this.renderHtTtcChart();
  }

  renderActifChart(): void {
    if (this.actifChart) {
      this.actifChart.destroy();
      this.actifChart = null;
    }

    const ctx = this.actifChartRef?.nativeElement;
    if (!ctx) return;

    this.actifChart = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: ["Actifs", "Passifs"],
        datasets: [{
          data: [this.stats.actifs, this.stats.passifs],
          backgroundColor: ["#28a745", "#dc3545"],
          borderWidth: 0,
        }],
      },
      options: {
        responsive: true,
        plugins: {
          legend: { position: "bottom" },
        },
      },
    });
  }

  renderHtTtcChart(): void {
    if (this.htTtcChart) {
      this.htTtcChart.destroy();
      this.htTtcChart = null;
    }

    const ctx = this.htTtcChartRef?.nativeElement;
    if (!ctx) return;

    this.htTtcChart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: ["Total HT", "Total TTC"],
        datasets: [{
          label: "Montants (€)",
          data: [this.stats.total_ht, this.stats.total_ttc],
          backgroundColor: ["#20c997", "#fd7e14"],
          borderRadius: 8,
          borderWidth: 0,
        }],
      },
      options: {
        responsive: true,
        plugins: {
          legend: { display: false },
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: (value) => `${value} €`,
            },
          },
        },
      },
    });
  }
}